import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-394e8ca4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    id: "limits",
    class: "limits"
};
const _hoisted_2 = { class: "limits__header" };
const _hoisted_3 = { class: "limits__title" };
const _hoisted_4 = { class: "limits__card" };
const _hoisted_5 = { class: "limits__list" };
const _hoisted_6 = { class: "limits__list-item-title" };
const _hoisted_7 = { class: "icon icon-question-12px" };
const _hoisted_8 = { class: "limits__list-item-value-container" };
const _hoisted_9 = { class: "limits__list-item-value" };
const _hoisted_10 = { class: "limits__list-item-value" };
import { fetchLimits } from '@/features/SoftLimits/data/fetchLimits';
import { useMixpanelConfig } from '@/utilities/mixpanel';
import { formatDecimal } from '@/utilities/formatters';
import BaseLoader from '@/components/_atoms/BaseLoaderSpinner.vue';
import InfoCard from '@/components/_atoms/InfoCard.vue';
import { reactive, onMounted } from 'vue';
import i18n from '@/i18n';
const ARTICLE_LINK = 'https://ajuda.otocrm.com.br/support/solutions/articles/150000190496-passo-a-passo-acompanhe-os-recursos-contratados-no-plano-oto-';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SoftLimits',
    setup(__props) {
        const state = reactive({
            limits: [],
            isLoading: true,
            hasError: false,
        });
        const formatValuesByType = (type, value) => {
            if (type === 'date') {
                const formattedMonth = i18n.global.tc('month', value).toLocaleLowerCase();
                return `${value} ${formattedMonth}`;
            }
            return formatDecimal(value);
        };
        const loadLimits = () => {
            fetchLimits()
                .then(limits => {
                state.limits = limits;
            })
                .catch(() => {
                state.hasError = true;
            })
                .finally(() => {
                state.isLoading = false;
            });
        };
        onMounted(() => {
            useMixpanelConfig('view_settings_planLimits');
            loadLimits();
        });
        return (_ctx, _cache) => {
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('settings.limits.title')), 1)
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("ul", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.limits, (limit, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                                class: "limits__list-item",
                                key: index
                            }, [
                                _createElementVNode("span", _hoisted_6, [
                                    _createTextVNode(_toDisplayString(limit.title) + " ", 1),
                                    _withDirectives(_createElementVNode("i", _hoisted_7, null, 512), [
                                        [_directive_tooltip, {
                                                theme: 'default',
                                                content: `<div class='limits__tooltip'>${limit.tooltip}<div>`,
                                                html: true,
                                                distance: 8,
                                            }]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("p", _hoisted_9, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('settings.limits.hired')), 1),
                                        _createElementVNode("strong", null, _toDisplayString(formatValuesByType(limit.type, limit.value.hired)), 1)
                                    ]),
                                    _createElementVNode("p", _hoisted_10, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('settings.limits.used')), 1),
                                        _createElementVNode("strong", null, _toDisplayString(formatValuesByType(limit.type, limit.value.used)), 1)
                                    ])
                                ])
                            ]));
                        }), 128))
                    ]),
                    _withDirectives(_createElementVNode("a", {
                        href: ARTICLE_LINK,
                        target: "_blank",
                        class: "limits__footer-text"
                    }, _toDisplayString(_ctx.$t('settings.limits.link')), 513), [
                        [_vShow, state.limits.length]
                    ])
                ]),
                _withDirectives(_createVNode(BaseLoader, null, null, 512), [
                    [_vShow, state.isLoading]
                ]),
                _withDirectives(_createVNode(InfoCard, {
                    ref: "message-error",
                    error: state.hasError
                }, null, 8, ["error"]), [
                    [_vShow, state.hasError]
                ])
            ]));
        };
    }
});
